
import React from 'react';
import { Calculator } from './Calculator';

export const CalculatorSection = () => {
  return (
    <section id="calculator" className="py-16 bg-gradient-to-br from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <Calculator />
        </div>
      </div>
    </section>
  );
};
